export default __webpack_public_path__ + "static/media/smog-solid.8630408b.svg";